module.exports = __webpack_public_path__ + "img/pig.8905e6f8.png";